// Auth context — this app uses Amplify auth exclusively.
// The AuthProvider simply wraps the app with AmplifyAuthProvider.
import type { ReactNode } from 'react';

import { createElement } from 'react';

import { AmplifyAuthProvider } from './amplify';

// ----------------------------------------------------------------------

type Props = { children: ReactNode };

export function AuthProvider({ children }: Props) {
  return createElement(AmplifyAuthProvider, undefined, children);
}
